/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IActionContext, getUrlSync } from '@msdyn365-commerce/core';

export const GetCheckoutReturnUrl = (actionContext: IActionContext): string => {
    let returnUrl = getUrlSync('checkout', actionContext) || '';
    const absoluteUrlRegExp = new RegExp('^(?:[a-z]+:)?//', 'i');
    const isAbsoluteUrl = absoluteUrlRegExp.test(returnUrl);
    if (window && !isAbsoluteUrl) {
        returnUrl = `${window.location.origin}${returnUrl}`;
    }

    return `${returnUrl}${!returnUrl.includes('?') ? '?' : '&'}pv=1`;
};
